import PolicyPage from "./PolicyPage";

const FAQS = [
  {
    section: "Shipping & Delivery",
    items: [
      {
        q: "How long does shipping take?",
        a: "Every Smibha Luxe Candles order ships via Canada Post from our Cambridge, Ontario studio the same business day when placed before 1:00 PM ET. Delivery within Canada takes 3–5 business days; international destinations (US, UK, EU) take 7–14 business days. All orders are tracked end-to-end.",
      },
      {
        q: "Do you ship internationally?",
        a: "Yes. We currently ship to Canada, the United States, the United Kingdom, and the European Union via Canada Post tracked international. Duties and taxes, where applicable, are the responsibility of the recipient. Additional regions are added each season — if your country isn't listed yet, write to info@smibhaluxecandles.com and we'll let you know when we open shipping to you.",
      },
      {
        q: "How can I track my order?",
        a: "A Canada Post tracking link is emailed to you the moment your shipping label is generated, and a second update follows once the carrier scans the parcel into transit. You can also reply to your order confirmation at any time and our care team will share the latest status. Please allow up to 24 hours after dispatch for the carrier's system to begin reporting movement.",
      },
    ],
  },
  {
    section: "Returns & Refunds",
    items: [
      {
        q: "What is your return policy?",
        a: "We generally do not accept returns for change of mind or unwanted products. If your product is defective, damaged, unsafe or not as described, contact us at info@smibhaluxecandles.com and we'll provide any remedy required by law. Approved refunds are sent to the original payment method. Please don't return products without written instructions from us unless the law allows you to do so.",
      },
      {
        q: "My order arrived damaged — what do I do?",
        a: "Contact us at info@smibhaluxecandles.com within 48 hours with your order number and photos of the package and product, and keep all packaging. We may offer a replacement or a refund, as required by law.",
      },
      {
        q: "When will I see my refund?",
        a: "Approved refunds are issued to your original payment method. You'll receive an email confirmation the moment the refund is initiated on our side; most banks then post the credit within a few business days.",
      },
    ],
  },
  {
    section: "Candle Care",
    items: [
      {
        q: "How should I burn my candle for the longest life?",
        a: "Trim the cotton wick to 5 mm before each light, and always burn the candle long enough for the entire surface of wax to liquify — this prevents tunneling and unlocks the full fragrance throw. We recommend a maximum burn of 3 hours per session.",
      },
      {
        q: "What wax and wicks do you use?",
        a: "Every Smibha Luxe candle is hand-poured from a premium soy or coconut-soy wax blend with vegan, fragrance-grade scent oils — never paraffin, never synthetic dyes. Wicks are hand-tied cotton (CD or HTP series), chosen per fragrance for an even, smoke-free flame.",
      },
      {
        q: "Are your candles non-toxic and clean-burning?",
        a: "Yes. Our waxes are food-grade, GMO-free soy and coconut blends; our fragrance oils are IFRA-certified, phthalate-free, and free of carcinogens or reproductive toxins listed on California Prop 65. Burned correctly, every Smibha Luxe candle is safe around pets and children.",
      },
    ],
  },
  {
    section: "Orders & Payment",
    items: [
      {
        q: "Which payment methods do you accept?",
        a: "Checkout is secured by Stripe and accepts Visa, Mastercard, American Express, Discover, Apple Pay, Google Pay, and Link. All transactions are encrypted end-to-end; we never see or store your full card number on our servers.",
      },
      {
        q: "Can I change or cancel my order?",
        a: "Because we begin preparing orders the moment they're placed, cancellations are only possible before the order enters our packing queue — typically within two hours of checkout. Email info@smibhaluxecandles.com immediately with your order number and we'll do everything we can to catch it in time. Cancellation isn't guaranteed once an order has been processed or shipped.",
      },
      {
        q: "Do you offer gift wrapping?",
        a: "Every Smibha Luxe candle ships in our signature hand-wrapped presentation box at no additional cost. For gifts shipping directly to a recipient, leave a handwritten message in the order notes field at checkout — we'll include it on our embossed Smibha card stock.",
      },
    ],
  },
];

function FaqItem({ q, a, idx }) {
  return (
    <details
      className="group border-b border-zinc-200 py-5"
      data-testid={`faq-item-${idx}`}
    >
      <summary className="flex items-start justify-between cursor-pointer list-none">
        <span className="text-base font-bold tracking-tight pr-6" style={{ fontFamily: "Outfit" }}>
          {q}
        </span>
        <span className="text-2xl font-light luxe-text group-open:rotate-45 transition-transform">
          +
        </span>
      </summary>
      <p className="text-zinc-600 leading-relaxed mt-3 pr-6 text-sm">
        {a}
      </p>
    </details>
  );
}

export default function FAQPage() {
  let i = 0;
  return (
    <PolicyPage
      eyebrow="Help Centre"
      title="Frequently Asked Questions"
      lastUpdated="February 2026"
      testid="page-faq"
    >
      <p>
        Quick answers to the questions we hear most often at Smibha Luxe Candles. Can&rsquo;t find
        what you&rsquo;re looking for? Reach our care team on the{" "}
        <a href="/contact" className="underline">contact page</a> — we reply within one business
        day.
      </p>

      {FAQS.map((group) => (
        <div key={group.section} className="mt-12" data-testid={`faq-section-${group.section.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <div className="text-[10px] uppercase tracking-[0.3em] font-semibold luxe-text mb-3">
            {group.section}
          </div>
          <div className="border-t border-zinc-200">
            {group.items.map((it) => {
              i += 1;
              return <FaqItem key={it.q} q={it.q} a={it.a} idx={i - 1} />;
            })}
          </div>
        </div>
      ))}

      <p className="text-sm text-zinc-500 mt-12">
        Still have a question? Email{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a> or visit
        our <a className="underline" href="/contact">contact page</a> — we reply within one
        business day.
      </p>
    </PolicyPage>
  );
}
